import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import style from './style.css'

export default class LettersHintInput extends Component {
  constructor (props) {
    super(props)

    this.state = {
      answerConfig: {} // [letter index] --> letter input
    }
  }

  getTotalLetters () {
    return _.sum(this.props.hintConfig.wordsLength)
  }

  getNextAvailableLetterIndex (currentLetterIndex, increment = 1) {
    const nextLetterIndex = currentLetterIndex + increment
    if (nextLetterIndex < 1 || nextLetterIndex > this.getTotalLetters()) {
      return currentLetterIndex
    } else if (_.isEmpty(_.get(this.props.hintConfig, ['letters', nextLetterIndex]))) {
      return nextLetterIndex
    } else {
      return this.getNextAvailableLetterIndex(nextLetterIndex, increment)
    }
  }

  getNewAnswerConfig (inputLetter, letterIndex) {
    const newAnswerConfig = { ...this.state.answerConfig }
    newAnswerConfig[letterIndex] = inputLetter
    return newAnswerConfig
  }

  getAnswerValue (answerConfig) {
    const fullAnswerObj = _.cloneDeep(this.props.hintConfig.letters)

    _.forEach(fullAnswerObj, (value, index) => {
      if (!value) {
        fullAnswerObj[index] = answerConfig[index]
      }
    })

    let minCount = 0 // exclusive
    let maxCount = 0 // inclusive
    return _.map(this.props.hintConfig.wordsLength, (wordLength) => {
      minCount = maxCount
      maxCount = maxCount + wordLength

      const filteredArray = _.filter(fullAnswerObj, (inputLetter, letterIndexKey) => {
        const letterIndexNumber = _.parseInt(letterIndexKey)
        return letterIndexNumber <= maxCount && letterIndexNumber > minCount
      })
      const result = filteredArray.join('')
      return result
    })
      .join(' ')
  }

  onChange (event, letterIndex) {
    const inputLetter = event.target.value

    let nextFocusedLetterIndex
    if (_.isEmpty(inputLetter)) {
      nextFocusedLetterIndex = this.getNextAvailableLetterIndex(letterIndex, -1)
    } else {
      nextFocusedLetterIndex = this.getNextAvailableLetterIndex(letterIndex)
    }

    const newAnswerConfig = this.getNewAnswerConfig(inputLetter, letterIndex)
    this.setState({ answerConfig: newAnswerConfig })
    this.props.onAnswer(this.getAnswerValue(newAnswerConfig))

    this.refs['letter' + nextFocusedLetterIndex].focus() // triggers this.onFocus()
  }

  onFocus (event) {
    event.target.select()
  }

  onKeyDown (event, letterIndex) {
    if (
      (event.keyCode === 8 && _.isEmpty(event.target.value)) || // backspace and input is empty
      event.keyCode === 37 || // left arrow
      event.keyCode === 39 // right arrow
    ) {
      let letterIndexIncrement = -1 // move backwards if left arrow or backspace
      if (event.keyCode === 39) {
        letterIndexIncrement = 1 // move forwards if right arrow
      }

      const nextFocusedLetterIndex = this.getNextAvailableLetterIndex(letterIndex, letterIndexIncrement)
      this.refs['letter' + nextFocusedLetterIndex].focus() // triggers this.onFocus()
      event.preventDefault() // don't delete or unselect the letter in the next input
    }
  }

  render () {
    const hintConfig = this.props.hintConfig
    let letterIndex = 0 // 1-indexed, letterIndex will never have a value of 0
    return (
      <div>
        {
          _.map(hintConfig.wordsLength, (wordLength, wordIndex) => (
            <span className={style.wordHintGroup} key={wordIndex}>
              {
                _.times(wordLength, (letterInWordIndex) => {
                  letterIndex += 1
                  const letterIndexCopy = letterIndex // freeze the value of letterIndex in this scope
                  const inputRef = 'letter' + letterIndexCopy

                  const letterHintValue = _.get(hintConfig, ['letters', letterIndexCopy])
                  const disabled = !!(this.props.isComplete || letterHintValue)
                  const isLastIndex = letterIndex === (wordLength)
                  let inputClass = letterHintValue || this.props.isCorrect
                    ? style.hintInput
                    : style.hintInputField
                  inputClass = isLastIndex ? style.hintInputLastIndex : inputClass
                  return (
                    <input
                      type="text"
                      ref={inputRef}
                      value={letterHintValue || undefined} // if letterHintValue is empty, then don't set a value
                      disabled={disabled}
                      onFocus={this.onFocus.bind(this)}
                      onChange={(event) => this.onChange(event, letterIndexCopy)}
                      onKeyDown={(event) => this.onKeyDown(event, letterIndexCopy)}
                      size={1}
                      maxLength={1}
                      key={letterIndexCopy + (letterHintValue || '')}
                      className={inputClass}
                      tabIndex="0"
                    />
                  )
                })
              }
            </span>
          ))
        }
      </div>
    )
  }
}

LettersHintInput.propTypes = {
  hintConfig: PropTypes.object.isRequired,
  onAnswer: PropTypes.func.isRequired,
  isComplete: PropTypes.bool,
  isCorrect: PropTypes.bool
}
